import React from "react";

const Footer = () => {
  return (
    <>
      <div className="border border-gray-500 md:w-[1200px] md:ml-[100px]" />

      <div className=" mt-10 w-full items-center justify-center flex flex-col">
        Copyright @ 2025 SymlarDev | All right Reserved.
      </div>
    </>
  );
};

export default Footer;
